module.exports = __webpack_public_path__ + "img/emi.c01b7f74.svg";